// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#2daf8e","colorSecondary":"#d3d61f","colorRed":"#b70000"};